/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the CraveTheory cart drawer scope.
 * - openCart: open the CT cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('ct-cart-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void, isOpen?: boolean} | null} */
      const drawer = document.querySelector('ct-cart-drawer#cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        // Idempotent — safe if CartLinesUpdateEvent already opened it
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
